import React, { useState, useEffect } from 'react';
import LOGO from './assets/footer-logo.png';
const menuItems = [
  { label: 'HOME', id: 'homeSection' },
  { label: 'Join Founding Agents', id: 'aboutusSection' },
  { label: 'Features', id: 'featuresSection' },
  { label: 'First 500 Agents', id: 'section1' },
  { label: "What's coming", id: 'section2' },
  { label: 'Lock your support', id: 'ctaSection' },
];

const NavBar = () => {
  const [active, setActive] = useState('homeSection');
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    setMenuOpen(false);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full bg-white z-50 ${isMobile ? 'border-b border-gray-200' : ''
        }`}
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <div className="max-w-screen-xl mx-auto px-3 py-3 flex items-center justify-between">

        {isMobile && (
          <div className="flex-shrink-0 flex items-center">
            <img
              src={LOGO}
              alt="Logo"
              className="h-12 w-auto"
            />
          </div>
        )}


        <ul
          className="hidden md:flex flex-1 justify-center space-x-8 mt-2"
          style={{ color: '#1D3340', fontWeight: 700 }}
        >
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => handleClick(item.id)}
                className={`px-2 py-2 rounded transition focus:outline-none font-inter ${active === item.id ? 'font-bold text-black' : 'font-normal text-[#6B729F]'
                  }`}
                style={{
                
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 700,
                }}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>


        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className="md:hidden flex items-center justify-center text-[#1d3340] focus:outline-none"
          aria-label="Toggle menu"
        >
          <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h20M4 14h20M4 21h20" />
          </svg>
        </button>
      </div>


      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <ul
            className="flex flex-col items-center py-4 space-y-2"
            style={{ color: '#1d3340', fontWeight: 700, fontFamily: "'Inter', sans-serif" }}
          >
            {menuItems.map((item) => (
              <li key={item.id} className="w-full">
                <button
                  onClick={() => handleClick(item.id)}
                  className={`w-full text-center px-3 py-2 rounded transition focus:outline-none ${active === item.id ? 'font-bold' : 'font-normal text-[#6B729F]'
                    }`}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
